import SurveyLikertQuestion from "./SurveyLikertQuestion";
import SurveyMCQQuestion from "./SurveyMCQQuestion";
import SurveyTextQuestion from "./SurveyTextQuestion";

export default function SurveyQuestion({ item, value, onChange, disableClicks, setDisableClicks }) {
  if (!item) return null;

  const renderInput = () => {
    switch (item.itemtype) {
      case "likert":
        return <SurveyLikertQuestion item={item} value={value} onChange={onChange} disableClicks={disableClicks} setDisableClicks={setDisableClicks}/>;
      case "mcq":
        return <SurveyMCQQuestion item={item} value={value} onChange={onChange} disableClicks={disableClicks} />;
      case "text":
        return <SurveyTextQuestion item={item} value={value} onChange={onChange} disableClicks={disableClicks} />;
      default:
        return null;
    }
  };

  return (
    <div className="mb-4 flex flex-col gap-2">
      {item.text && <p className="text-xl font-thin text-slate-900 text-center w-full">{item.text}</p>}
      {renderInput()}
    </div>
  );
}
